import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { isStinvestActiveClient } from '»utils/clientsUtils';

import { generalConditionsSlice } from '../GeneralConditions';

export const initialState = {
  auth: {
    isAuthenticated: false,
    isLoading: false,
    token: null,
    user: null,
    loginId: null,
    uuid: uuidv4(),
    showLogoutAlert: false,
    loginCurrentStep: 0,
    onboarding: {
      legalStatus: '',
      legalStatusList: [],
      error: '',
      currentStep: isStinvestActiveClient ? 0 : 1,
      mainFormFields: [],
      openingRequestId: '',
      legalStatus: '',
      ibanCode: '',
      ibanCode2: '',
      bankAccountNumber: '',
      holderCode: '',
      shouldShowQuestionnaire: '',
      contract: {
        file: '',
        disclaimer: '',
        isLoading: '',
      },
      documents: {},
      isJoinProcessCompleted: false,
    },
  },
};

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    resetAuth: (state) => {
      const updatedState = {
        ...initialState.auth,
        error: false,
        uuid: uuidv4(),
        onboarding: {
          ...initialState.auth.onboarding,
          ...(state.onboarding.createAccountDisclaimer !== undefined && {
            createAccountDisclaimer: state.onboarding.createAccountDisclaimer,
          }),
          ...(state.onboarding.legalStatus.length > 0 && {
            legalStatus: state.onboarding.legalStatus,
          }),
          ...(state.onboarding.legalStatusList.length > 0 && {
            legalStatusList: state.onboarding.legalStatusList,
          }),
        },
      };

      return updatedState;
    },
    newUuid: (state) => {
      state.uuid = uuidv4();
    },
    getUserProcessRequest: (state) => {
      state.isLoading = true;
    },
    getUserProcessSuccess: (state, action) => {
      const { value, processId } = action.payload;

      if (processId === 'COND_GERAIS') state.generalCond = value;

      state.isLoading = false;
    },
    getUserProcessFailure: (state) => {
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      generalConditionsSlice.actions.setGeneralConditionsSuccess,
      (state) => {
        state.generalCond = 'Y';
      },
    );
  },
});
